import {
    Dialog,
    DialogContent,
    DialogTrigger,
} from "@/components/ui/dialog";
import Icon from "@/icons";
import Tippy from "@tippyjs/react";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
const createTeam = async (template: any, navigate: any) => {
    const response = await fetch(`__SITE_BASE__/api/templates/${template.code}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
    });
    const data = await response.json();
    if (!response.ok) return toast.error(data.message);
    navigate(`/teams/${data.team}`);
    toast.success("Team created successfully");
};

export const TemplateDisplay = ({ children, template, team }: { children: React.ReactNode, template: any, team: any }) => {
    const [onOpen, setOnOpen] = useState(false);

    return (
        <Dialog open={onOpen} onOpenChange={onOpen => setOnOpen(onOpen)}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 min-w-min rounded-lg shadow-lg p-0 gap-0" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                <TemplateDisplayContent template={template} team={team} />
            </DialogContent>
        </Dialog>
    );
};

export const TemplateDisplayContent = ({ template, team }: { template: any, team: any }) => {
    const navigate = useNavigate();
    return (
        <>
            <div className="flex items-center">
                <div className="rounded-r-lg sm:rounded-r-none sm:rounded-l-lg gap-2 flex-col bg-brand-darkest text-white h-full w-auto flex items-center justify-center">
                    <div className="flex flex-col gap-2 items-center">
                        <div className="h-96 w-96 items-center text-center justify-center flex flex-col p-2">
                            <p className="font-bold">
                                Create a Team
                            </p>

                            <p>
                                with using <strong>{team.name}</strong> template
                            </p>

                        </div>
                    </div>
                </div>
                <div className="rounded-r-lg hidden sm:flex flex-col bg-brand-dark text-white w-96 p-2 h-full">
                    <h1 className="text-2xl font-bold text-center">
                        Setup your team
                    </h1>
                    <div className="h-full flex-col flex w-full justify-center">
                        <div className="flex flex-col w-full gap-2">
                            <h2 className="text-lg font-semibold">
                                Channels
                            </h2>
                            <div className="bg-brand-darkest overflow-auto rounded-lg p-2 space-y-2 w-full max-h-48" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                                {template.channels.map((channel: any) => (
                                    <>
                                        <div className="flex items-center gap-2  group-hover:text-white text-gray-400">
                                            {
                                                channel.type === "text" ?
                                                    <Icon name="hashtag" size="16" />
                                                    : channel.type === "todo" ?
                                                        <Icon name="todo" size="16" />
                                                        : channel.type === "watchstream" ?
                                                            <Icon name="stream" size="16" />
                                                            : channel.type === "whiteboard" ?
                                                                <Icon name="whiteboard" size="16" />
                                                                : channel.type === "voice" ?
                                                                    <Icon name="volume" size="16" />
                                                                    :
                                                                    <Icon name="hashtag" size="16" />
                                            }
                                            <h1 className={`font-semibold text-base group-hover:text-white truncate`}>{channel.name}</h1>
                                        </div>
                                    </>
                                ))}
                            </div>

                            <h2 className="text-lg font-semibold">
                                Roles
                            </h2>

                            <div className="bg-brand-darkest overflow-y-auto overflow-x-hidden flex-wrap rounded-lg flex p-2 gap-2 max-h-48" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>

                                {template.roles.sort((a: any, b: any) => b.priority - a.priority).map((role: any) => (
                                    <div key={role.id} className="flex items-center max-h-6 border rounded-lg hover:bg-brand-darkest cursor-pointer" style={{ borderColor: role.color, transform: "scale(1)" }} >
                                        <div className="flex items-center gap-2 min-w-24">
                                            <div className="w-4 h-4 rounded-full" style={{ background: role.color2 ? `linear-gradient(90deg, ${role.color}, ${role.color2})` : role.color }} />
                                            <p className="text-gray-300 font-semibold text-xs break-words">{role.name.length > 10 ? role.name.slice(0, 10) + "..." : role.name}</p>
                                        </div>
                                    </div>
                                ))}

                            </div>

                            <h2 className="text-lg font-semibold">
                                Emojis
                            </h2>

                            <div className="bg-brand-darkest overflow-y-auto overflow-x-hidden flex-wrap rounded-lg flex p-2 gap-2 max-h-48" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                                {template.emojis.map((emoji: any) => (
                                    <Tippy content={emoji.name} placement="top" arrow={false}>
                                        <div className="flex items-center gap-2  group-hover:text-white text-gray-400">
                                            <img src={emoji.url} className="w-6 h-6 rounded-lg" />
                                        </div>
                                    </Tippy>
                                ))}
                            </div>

                            <hr className="border-gray-600 w-full" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex items-center justify-between gap-4 p-4 bg-brand-top/50">
                <button
                    onClick={() => {
                        navigator.clipboard.writeText(window.location.origin + "/template/" + template.code);
                        toast.success("Template copied to clipboard");
                    }}
                    className="bg-gray-400 text-center px-5 py-2 w-64 rounded-lg text-white font-semibold hover:bg-gray-500 disabled:opacity-50"
                >
                    Share Template
                </button>


                <button
                    onClick={() => {
                        createTeam(template, navigate);
                    }}
                    className="bg-brand-green text-center px-5 py-2 w-64 rounded-lg text-white font-semibold hover:bg-green-500 disabled:opacity-50"
                >
                    Create Team
                </button>
            </div>
        </>
    )

};